export default __webpack_public_path__ + "static/beyondunity-logo.739e7ee9.svg";